//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.StyleBuilder.js";
let d=[[[0,"Color",1,0],[0,"Font",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"Width",1,0]],[[["sid"],"SelectComponent",{},1,0],[[],"ApplyStyle",{},0,0],[[],"ApplyCfw",{},0,0]],[]];
SPLM.Annotations.EditSymbolDisplayBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.EditSymbolDisplayBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.EditSymbolDisplayBuilder.FontTypes = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Annotations.EditSymbolDisplayBuilder.WidthTypes = Object.freeze({
    "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "ThicknessOne" : "ThicknessOne", "ThicknessTwo" : "ThicknessTwo", "ThicknessThree" : "ThicknessThree", "ThicknessFour" : "ThicknessFour", "ThicknessFive" : "ThicknessFive", "ThicknessSix" : "ThicknessSix", "ThicknessSeven" : "ThicknessSeven", "ThicknessEight" : "ThicknessEight", "ThicknessNine" : "ThicknessNine"});

export default SPLM;